// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import expertReducer from './slices/expertSlice';
import queueReducer from './slices/queueSlice';
import activeSessionReducer from './slices/activeSessionSlice'; // 🟢 IMPORT NEW SLICE

export const store = configureStore({
  reducer: {
    expert: expertReducer,
    queue: queueReducer,
    activeSession: activeSessionReducer, // 🟢 ADD HERE
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;